import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import isEmpty from 'lodash/isEmpty'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListEventCampaignPayload } from '@app-store/slices/campaigns/eventCampaignList'

interface TaskAction extends Action {
    payload: IListEventCampaignPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.campaigns.eventCampaignList

function* eventCampaignListSagaTask({ payload }) {
    try {
        const query: any = payload?.query || {}
        const pagination = payload?.pagination || undefined
        const params = {}

        if (!isEmpty(query)) Object.assign(params, { query })
        if (pagination) Object.assign(params, { ...pagination })

        const response = yield axios.get(`/notifications/campaigns/events`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* eventCampaignListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, eventCampaignListSagaTask)
}

export default eventCampaignListSaga
